export const treeMenuClassName = 'border-r border-block-color px-2 py-3 overflow-auto '
